<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">已办事项分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container :style="conheight">
      <collapse-search>
      <div class="content_top_wrap">
        <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button size="small" type="primary" @click="search('find')">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </div>
      </collapse-search>
      <el-main class="content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          header-cell-class-name="done-header-row"
          :row-class-name="tableRowClass"
          size="medium"
          height="100%"
          v-loading.fullscreen.lock="fullscreenLoading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="workorderno"
            width="120"
            align="left"
            label="工单号"
            sortable
          >
          </el-table-column> -->
          <el-table-column width="120" align="left" label="工单号">
            <template slot-scope="scope">
              <span>
                {{ scope.row.workorderno }}
              </span>
            </template>
          </el-table-column>

          

          <el-table-column label="流程事项">
            <template slot-scope="scope">
              <span class="done-subject" @click="handleRowClick(scope.row)">
                {{ scope.row.subject }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="流程名称"
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procdefname }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="状态"
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <el-badge v-if="scope.row.status == 'manualend' || scope.row.status == 'backToStart' || scope.row.status == 'back'" is-dot type="danger"></el-badge>
              <el-badge v-if="scope.row.status == 'end'" is-dot type="info"></el-badge>
              <el-badge v-if="scope.row.status == 'running'" is-dot type="success"></el-badge>



              <!-- primary / success / warning / danger / info -->

              <el-badge v-if="scope.row.status == 'end'" size="small" >结束</el-badge>
              <el-badge v-if="scope.row.status == 'manualend'" size="small" >人工终止</el-badge>
              <el-badge v-if="scope.row.status == 'backToStart'" size="small" >驳回到发起人</el-badge>
              <el-badge v-if="scope.row.status == 'back'" size="small" >驳回</el-badge>
              <el-badge v-if="scope.row.status == 'running'" size="small" >正在运行</el-badge>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="发起时间"
            align="left"
            width="160"
            sortable
            prop="createtime"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.createtime | dateformat("yyyy-MM-dd HH:mm:ss") }}
              </span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="creator"
            label="发起人"
            width="120"
            align="left"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="left"
          >
            <template slot-scope="scope">
              <eipTop 
                @search="search"
                :currentRow="scope.row"
                topType=1
                showItem="one">
              </eipTop>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row>
          <div style="display: initial;">
            <span style="padding-right:16px;font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #52535E;">已选 {{arrlen}}条</span>
            <el-button  size="small" @click="taskToCopyTo()">传阅</el-button>
          </div>
          <eipTop style="display:initial" @search="search" :topList="topList" topType=1 showItem="many"></eipTop>
          <div style="float: right;display: initial;">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-row>
      </el-footer>
      <el-dialog
        title="撤回"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          placeholder="请输入撤回意见"
          v-model="opinion"
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRevoke" size="small"
            >确 定</el-button
          >
          <el-button @click="exitRevoke" size="small">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 流程传阅-->
      <TaskToCopyTo ref="taskToCopyTo" :instId="ids"/>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import process from "@/api/process";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";
import eipOrgSelector from "@/components/eipControl/selector/EipOrgSelector.vue";
import searchForm from "@/components/common/searchForm.vue";
import eipTop from "@/components/eipControl/EipTop"

export default {
  name: "doneRead",
  components: {
    FlowTree,
    eipOrgSelector,
    TaskToCopyTo,
    searchForm,
    eipTop
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectId:'',
      dialogFormVisible:false,
      opinion:"",
      arrlen:0,
      activeNames: "",
      // isExpand: false,
      form: { tableData: "", date: "", orgName: "", orgId: "" },
      conheight: { height: "" },
      asideShow: false,
      currentTree: "",
      fullscreenLoading: true,
      sorter: [],
      urgentStateConf: {},
      urgentStateConfList: [],
      urgentStateVal: "",
      ids: "", //待办任务id集合
      defaultFiledShowConf: "",
      defaultFiledShowConfList: [
        { name: "subject", desc: "标题", frontShow: true },
        { name: "workOrderNo", desc: "工单号", frontShow: true},
        { name: "procInstId", desc: "流程编号", frontShow: true },
        { name: "procDefName", desc: "流程名称", frontShow: true},
        { name: "name", desc: "任务名称", frontShow: true },
        { name: "status", desc: "类型", frontShow: true },
        { name: "createTime", desc: "创建时间", frontShow: true },
        { name: "creator", desc: "创建人", frontShow: true },
        { name: "urgentStateValue", desc: "紧急状态", frontShow: true },
        { name: "dueExpDate", desc: "到期时间", frontShow: false },
        { name: "ownerName", desc: "所属人", frontShow: false },
        { name: "assigneeName", desc: "待审批人", frontShow: false },
        { name: "prop1", desc: "扩展1", frontShow: false },
        { name: "prop2", desc: "扩展2", frontShow: false },
        { name: "prop3", desc: "扩展3", frontShow: false },
        { name: "prop4", desc: "扩展4", frontShow: false },
        { name: "prop5", desc: "扩展5", frontShow: false },
        { name: "prop6", desc: "扩展6", frontShow: false }
      ],
      history: [],
      searchOptions: [
        {
          property: "subject",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        },
        {
          property: "procDefName",
          operation: "LIKE",
          type: "text",
          label: "流程名称",
          placeholder: "请输入流程名称"
        },
        {
          property: "wfInst.create_time_",
          operation: "IN",
          type: "datetimerange",
          label: "创建时间"
        },
        {
          property: "creator",
          operation: "LIKE",
          type: "text",
          label: "创建人",
          placeholder: "请输入创建人"
        },
        {
          label: "状态",
          property: "wfInst.status_",
          operation: "EQUAL",
          type: "select",
          placeholder: "请选择状态",
          options: [
          {
          value: "",
          label: "全部",
          },
          {
            value: "end",
            label: "结束",
          },
          {
            value: "manualend",
            label: "人工终止",
          },
          {
            value: "back",
            label: "驳回",
          },
          {
            value: "backToStart",
            label: "驳回到发起人",
          },
          {
            value: "running",
            label: "正在运行",
          }
            ]
          },
        {
          label: "发起组织",
          property: "createOrgId",
          placeholder: "请选择发起人组织",
          type: "orgSelector"
        }
      ],
      topList:[]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total
  }),
  watch: {
    "form.orgId": {
      handler(newName, oldName) {
        ///this.search("find");
      },
      immediate: true,
    },
  },
  methods: {
    //页面高度
    getHeight(){
          this.conheight.height = window.innerHeight - 112 + "px";
    },
        //选择状态查询
    statusChange(value) {
      this.statusData = value;
      this.search("find");
    },
    //流程传阅
    taskToCopyTo() {
      if (this.ids == "") {
        this.$message.warning("请选择要传阅的流程");
        return;
      }
      this.$refs.taskToCopyTo.handleClose(); //父组件调用子组件方法
    },
    //批量勾选待办流程获取
    handleSelectionChange(val) {
      this.ids = "";
      this.arrlen = val.length;
      this.topList = [];
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.ids = this.ids + val[i].id + ",";
          let topRow = {gdh:val[i].workorderno,topnum:val[i].topnum?val[i].topnum:0};
          this.topList.push(topRow);
        }
        this.ids = this.ids.substring(0, this.ids.length - 1);
      }
    },
    formatDate(value) {
      return utils.formatDate(value.createTime);
    },
    handleClose(done) {
      this.dialogFormVisible = true;
    },
    //撤回到上一个节点
    handleRevoke(id) {
      this.dialogFormVisible = true;
      this.id = id;
    },
    saveRevoke() {
      if (this.opinion == "") {
        this.$message.warning("请填写撤回意见");
        return false;
      }
      let data = {
        instanceId: this.id,
        isHandRevoke: true,
        cause: this.opinion,
      };
      this.$store.dispatch("storeProcess/revokeInstance", data).then(() => {
        this.dialogFormVisible = false;
        this.opinion = "";
        this.search();
      });
    },
    exitRevoke() {
      this.dialogFormVisible = false;
      this.opinion = "";
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
   // 查询
    search(str) {
      console.log('-------------------------')
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      if (this.currentTree) {
        querys.push({
          property: "bt.type_id_",
          value: this.currentTree,
          group: "typeId",
          operation: "IN",
          relation: "AND"
        });
      }
      if (this.defKey) {
        querys.push({
          property: "bt.proc_def_key_",
          value: this.defKey,
          operation: "EQUAL",
          relation: "AND"
        });
      }
      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getDoneByPagination", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      //判断是否显示撤回按钮
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      if (row.status == 'backToStart' || row.status == 'back' || row.status =='running') {
        url = url + "/inst/" + row.id + "/doneList";
      } else {
        url = url + "/inst/" + row.id + "/read";//doneList
      }
      url = url + "?token=" + token;
      window.open(
        url,
        "_blank",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 70)
      );
    },
    //子组件传值父组件(已办分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.currentTree = "";
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
      }
      this.search("find");
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      let pageBean = {};
      return process.getDoneInstCount(pageBean);
    },
    tableRowClass(rows){
      if(rows.row.topnum){
        return 'row-class';
      }
      return 'done-row';
    }
  },
  created() {
    //页面高度设置
      window.addEventListener('resize', this.getHeight);
      window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
      this.getHeight();

    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND",
      });
    }
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys,
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getDoneByPagination", pageBean)
      .then(() => {
        //页面加载调用done.js里面的分页方法
        this.fullscreenLoading = false;
      });
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
@import "@/assets/css/iconfont.scss";
  /deep/ .el-badge__content.is-dot{
    margin-top: 10px !important;
    margin-right: 8px !important;
    width: 6px !important;
    height: 6px !important;
  }

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}


/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 


/deep/ .el-main .base-main{//隐藏外层滚动条
    overflow:hidden !important;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}


.list_main_content {
  padding: 0;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}

   .form_select__status {
      margin-right: 10px;
      display: flex;
      flex-direction: row;
    }
    .form_select__status {
      width: 100%;
      p {
        white-space: nowrap;
        width: 30px;
        margin: 8px;
      }
    }

/deep/.el-table th{
  height: 48px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}
// /deep/.el-table tr:nth-child(even){
//     background: rgb(240, 241, 241);
// }

/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
  background-color:#EDF6FB !important;
    .done-subject{
      color: #1890FF !important;
    }
    .done-subject-read{
      color: #1890FF !important;
    }
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}



/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}

/deep/ .el-badge{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/.todo-subject,
/deep/.el-tooltip>span{
  font-size: 12px !important;
}
.el-table /deep/ tr.done-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}

.el-table /deep/ tr.row-class{
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
  background-color: #eee;
}

/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 0px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.el-container {
  background-color: #fff;
}

.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 0px solid #ededed;
}

.done-subject {
  cursor: pointer;
}

.done-subject {
  color: $--theme-color;
}

.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}

/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.content {
  padding: 0px;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 0px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
</style>
